import { render, staticRenderFns } from "./TipTapMentionList.vue?vue&type=template&id=301aacdb&"
import script from "./TipTapMentionList.vue?vue&type=script&lang=js&"
export * from "./TipTapMentionList.vue?vue&type=script&lang=js&"
import style0 from "./TipTapMentionList.vue?vue&type=style&index=0&id=301aacdb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports